import type { StatusSolicitacao } from '@/features/solicitacoes/status';
import type { PerfilUsuario } from '@/features/auth/tipos';

/**
 * Espelho de `backend/src/cancelamentos/alcada.ts`.
 *
 * Existe para a tela não oferecer um botão que o servidor vai recusar — e para
 * dizer o porquê no lugar dele. Quem decide de verdade é o backend: qualquer
 * divergência aqui vira mensagem de erro, não permissão indevida.
 */

/** Status a partir dos quais ainda faz sentido cancelar. */
export const STATUS_CANCELAVEIS: StatusSolicitacao[] = [
  'ENVIADO',
  'LIDO_PELA_REGULACAO',
  'PENDENCIA_DOCUMENTACAO',
  'EM_PROCESSO',
  'AGENDADO',
];

export function podeSolicitarCancelamento(status: StatusSolicitacao): boolean {
  return STATUS_CANCELAVEIS.includes(status);
}

/**
 * Perfis com alçada para confirmar ou recusar, dado o status atual.
 *
 * Agendada exige a Regulação: cancelar desmarca um atendimento e devolve a
 * vaga no eSUS, que é onde só ela consegue mexer.
 */
export function podeDecidirCancelamento(perfil: PerfilUsuario, status: StatusSolicitacao): boolean {
  if (status === 'AGENDADO') return perfil === 'REGULACAO';
  return perfil === 'REGULACAO' || perfil === 'GESTOR' || perfil === 'ADMINISTRADOR';
}
